const PAGARME_API_URL = 'https://api.pagar.me/core/v5';

const Pagarme = {
  async createCardToken(cardData) {
    const publicKey = window.PAGARME_PUBLIC_KEY;

    if (!publicKey) {
      throw new Error('PAGARME_PUBLIC_KEY não configurada');
    }

    const [expMonth, expYear] = cardData.expiry.split('/');
    const fullYear = expYear.length === 2 ? `20${expYear}` : expYear;

    const payload = {
      card: {
        number: cardData.number.replace(/\s/g, ''),
        holder_name: cardData.name,
        exp_month: parseInt(expMonth, 10),
        exp_year: parseInt(fullYear, 10),
        cvv: cardData.cvv
      }
    };

    const response = await fetch(`${PAGARME_API_URL}/tokens?appId=${publicKey}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Erro ao tokenizar cartão');
    }

    const data = await response.json();
    return data.id;
  }
};

export default Pagarme;
